import {TEXT, UPDATED_AT, settingsJson, userId} from '../constants/stringsAndFields';
import {isNotEmpty} from '../utils/arrays';
import {
  checkTableExists,
  insertData,
  selectData,
  updateData,
} from './common';
import {APP_USER_TABLE} from './user';
import {LOCAL_DEFAULT_USER_ID} from './userConstants';
import {runSqlCmd, exportDatabase} from './sqlOperations';

export const USER_SETTINGS_TABLE = 'UserSettings';

export const userSettingsKeys = [userId, settingsJson, UPDATED_AT];

const defaultUserIdSql = `'${LOCAL_DEFAULT_USER_ID}'`;

export const createUserSettingsTable = async tx => {
  await runSqlCmd(
    tx,
    `CREATE TABLE IF NOT EXISTS ${USER_SETTINGS_TABLE}(
      ${userId} ${TEXT} PRIMARY KEY NOT NULL,
      ${settingsJson} ${TEXT} NOT NULL DEFAULT '{}',
      ${UPDATED_AT} ${TEXT},
      FOREIGN KEY(${userId}) REFERENCES ${APP_USER_TABLE}(${userId}) ON DELETE CASCADE);`,
  );
};

export const ensureDefaultUserSettings = async tx => {
  const rows = await selectData(
    tx,
    USER_SETTINGS_TABLE,
    userSettingsKeys,
    userId,
    LOCAL_DEFAULT_USER_ID,
    [],
    false,
    'LIMIT 1',
  );
  if (isNotEmpty(rows)) {
    return;
  }
  await runSqlCmd(
    tx,
    `INSERT OR IGNORE INTO ${USER_SETTINGS_TABLE} (${userId}, ${settingsJson}, ${UPDATED_AT})
     VALUES (${defaultUserIdSql}, '{}', CURRENT_TIMESTAMP);`,
  );
};

export const getUserSettingsRow = async (tx, uid = LOCAL_DEFAULT_USER_ID) => {
  const rows = await selectData(
    tx,
    USER_SETTINGS_TABLE,
    userSettingsKeys,
    userId,
    uid,
    [],
    false,
    'LIMIT 1',
  );
  return isNotEmpty(rows) ? rows[0] : null;
};

export const upsertUserSettings = async (tx, row) => {
  await insertData(tx, USER_SETTINGS_TABLE, userSettingsKeys, row);
  await exportDatabase(tx);
};

export const updateUserSettingsJson = async (tx, uid, jsonObject) => {
  const payload = {
    [userId]: uid,
    [settingsJson]:
      typeof jsonObject === 'string' ? jsonObject : JSON.stringify(jsonObject),
  };
  await updateData(tx, USER_SETTINGS_TABLE, payload, userId);
  await exportDatabase(tx);
};

export const checkUserSettingsTable = async tx => {
  return await checkTableExists(tx, USER_SETTINGS_TABLE);
};
